import { render, staticRenderFns } from "./DialogosGlobales.vue?vue&type=template&id=55229c26&scoped=true"
import script from "./DialogosGlobales.vue?vue&type=script&lang=js"
export * from "./DialogosGlobales.vue?vue&type=script&lang=js"
import style0 from "./DialogosGlobales.vue?vue&type=style&index=0&id=55229c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55229c26",
  null
  
)

export default component.exports